import template from './notes_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class NotesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class NotesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new NotesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'NotesHelp',
	dialog_class: NotesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/notes_help',
	provider: 'ps'
};
